import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { host } from './../components/host.js'
import Loading from './../components/loading'
import { Fade } from 'react-reveal';
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import NumberFormat from 'react-number-format';
import Sidebar from '../components/sidebar'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Jumbotron from 'react-bootstrap/Jumbotron'
import Breadcrumb from 'react-bootstrap/Breadcrumb'

const CalculationComponent = () => {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [timer, setTimer] = useState(null)
    const [calculate, setCalculate] = useState({
        error: null,
        isLoaded: false,
        calculate: [],
    });
    let history = useHistory();

    const dataFetching = (a, b, c) => {
        setIsLoaded(false);
        axios.get(host(window.location.hostname) + "/Plugins/CalculateLoansProduct", {
            params: {
                CalculationTypeId: 1,
                ProductTypeId: "GMENKULKONUTYENI",
                Cost: 0,
                InstalmentAmountDisplay: 0,
                InstalmentAmount: 0,
                LoanAmount: Number(a),
                LoanMaturity: Number(b),
                CustomRate: Number(c),
                LoanSegmentId: 2
            }
        })
            .then(res => {
                setCalculate(res.data);
                setIsLoaded(true);
            })
            .catch(error => {
                console.log(error);
                setError(error);
            });
    }

    useEffect(() => {
        dataFetching(1000, 1, 0);
    }, []);

    const handleFocus = (event) => event.target.select();

    const handleChange = (event) => {
        clearTimeout(timer)
        const { name: key, value } = event.target
        let updatedCalculate = { ...calculate };

        if (key === "FundingAmount") {
            let FundingAmount = value.replace(' ₺', '').replaceAll('.', '').replaceAll(',', '');
            if (value === null || value === "") {
                FundingAmount = 1000;
            }
            if (FundingAmount < 0) {
                FundingAmount = 1;
            } else if (FundingAmount > 1000000000000) {
                FundingAmount = 1000000000000;
            }
            updatedCalculate.Data[key] = FundingAmount;
        } else if (key === "InstallmentCount") {
            let InstallmentCount = value.replaceAll('.', '').replaceAll(',', '');
            if (InstallmentCount < 1) {
                InstallmentCount = 1;
            } else if (InstallmentCount > 120) {
                InstallmentCount = 120;
            }
            updatedCalculate.Data[key] = InstallmentCount;
        } else if (key === "ProfitRate") {
            let ProfitRate = value.replaceAll(',', '.');
            if (ProfitRate < 0) {
                ProfitRate = 1;
            } else if (ProfitRate > 10) {
                ProfitRate = 10;
            }
            calculate.Data[key] = ProfitRate;
        } else {
            updatedCalculate.Data[key] = value;
        }

        setCalculate(updatedCalculate);
        const newTimer = setTimeout(() => {
            dataFetching(updatedCalculate.Data.FundingAmount, updatedCalculate.Data.InstallmentCount, updatedCalculate.Data.ProfitRate);
        }, 1000)
        setTimer(newTimer)
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        let FundingAmount = "FundingAmount=" + calculate.Data.FundingAmount;
        let InstallmentCount = "InstallmentCount=" + calculate.Data.InstallmentCount;
        let ProfitRate = "ProfitRate=" + calculate.Data.ProfitRate;

        history.push(`/finansman-hesaplama-detay/?${FundingAmount}&${InstallmentCount}&${ProfitRate}`);
    };
    if (error) {
        return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
        return <Loading />;
    } else {
        return (
            <>
                <Jumbotron className="subpageHeader" fluid>
                    <Fade>
                        <Container>
                            <h1>Finansman Hesaplama</h1>
                            <Breadcrumb>
                                <Breadcrumb.Item href="/">Ana Sayfa</Breadcrumb.Item>
                                <Breadcrumb.Item active>Finansman Hesaplama</Breadcrumb.Item>
                            </Breadcrumb>
                        </Container>
                    </Fade>
                </Jumbotron>
                <section>
                    <Container>
                        <Row>
                            <Col className="subpageContent" sm={9}>
                                <Fade bottom>
                                    <Row>
                                        <Col md={{ span: 8, offset: 2 }}>
                                            <Form onSubmit={handleSubmit}>
                                                <Form.Row>
                                                    <Form.Group as={Col} className="col-12 col-lg-6" controlId="financeamount">
                                                        <Form.Label>Finansman Tutarı</Form.Label>
                                                        <Form.Control
                                                            as={NumberFormat}
                                                            min="1"
                                                            max="10000000"
                                                            thousandSeparator={'.'}
                                                            autoComplete="off"
                                                            name="FundingAmount"
                                                            decimalSeparator={','}
                                                            value={calculate.Data?.FundingAmount}
                                                            onChange={handleChange}
                                                            onClick={handleFocus}
                                                            placeholder="Finansman Tutarı Giriniz (TL)"
                                                            suffix={' ₺'} />
                                                    </Form.Group>

                                                    <Form.Group as={Col} className="col-12 col-lg-6" controlId="financematurity">
                                                        <Form.Label>Vade</Form.Label>
                                                        <Form.Control
                                                            name="InstallmentCount"
                                                            value={calculate.Data?.InstallmentCount}
                                                            autoComplete="off"
                                                            step="1"
                                                            min="1"
                                                            max="120"
                                                            placeholder="Vade Giriniz (Ay)"
                                                            onChange={handleChange}
                                                            onClick={handleFocus}
                                                        />
                                                    </Form.Group>
                                                </Form.Row>

                                                <Form.Row className="mb-4">
                                                    <Form.Group as={Col} className="col-12 col-lg-6" controlId="financerate">
                                                        <Form.Label>Finansman Oranı</Form.Label>
                                                        <Form.Control
                                                            name="ProfitRate"
                                                            autoComplete="off"
                                                            value={calculate.Data?.ProfitRate}
                                                            step=".01"
                                                            min="0"
                                                            max="5"
                                                            placeholder="Finansman Oranı"
                                                            onChange={handleChange}
                                                            onClick={handleFocus}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} className="col-12 col-lg-6" controlId="financeinstalment">
                                                        <Form.Label>Taksit Tutarı</Form.Label>
                                                        <NumberFormat
                                                            thousandSeparator={'.'}
                                                            decimalSeparator={','}
                                                            className="form-control"
                                                            readOnly
                                                            value={calculate.Data?.InstallmentContractList[0].Amount}
                                                            placeholder="Taksit Tutarı giriniz (TL)"
                                                            suffix={' ₺'}
                                                        />
                                                    </Form.Group>
                                                </Form.Row>

                                                <Form.Row className="justify-content-lg-center mb-5">
                                                    <Col className="col-12 col-lg-6">
                                                        <Button type="submit" variant="outline-secondary">
                                                            İNCELE
                                                        </Button>
                                                    </Col>
                                                </Form.Row>
                                            </Form>
                                        </Col>
                                    </Row>
                                </Fade>
                            </Col>
                            <Col sm={3}>
                                <Sidebar />
                            </Col>
                        </Row>
                    </Container>
                </section>
            </>
        );
    }
};

export default CalculationComponent;